import { apiGet, apiPost, apiPut, apiRequest, RequestMethod } from '.';
import {
  BareVenueTemplate,
  VenueTemplate,
  NewVenueTemplate,
  SimpleVenueTemplate,
  VenueOrder,
  PaginateVenueTemplateParams,
} from '../../../shared/types/venueTemplate';
import { populateVenueTemplate } from '@go-shared/lib/venue';
import { PaginationResult } from '@go-shared/types/pagination';
import qs from 'query-string';

export async function getSimpleVenuesTemplates(): Promise<SimpleVenueTemplate[]> {
  let venueTemplates = (await apiGet('/simple-venue-template')) as any;
  return venueTemplates;
}

export async function getVenueTemplates(): Promise<BareVenueTemplate[]> {
  let venueTemplates = (await apiGet(`/venue-template`)) as any;
  return venueTemplates;
}

export async function getVenueTemplatesByPropertyId(
  propertyId: string
): Promise<BareVenueTemplate[]> {
  const venueTemplates = (await apiGet(`/property/${propertyId}/venue-template`)) as any;
  return venueTemplates;
}

export async function paginateVenueTemplates(
  params: PaginateVenueTemplateParams
): Promise<PaginationResult<VenueTemplate>> {
  return apiGet(`/venue-template/paginate?${qs.stringify(params)}`);
}

export async function getVenueTemplateById(
  propertyId: string,
  venueTemplateId: string
): Promise<BareVenueTemplate> {
  const venueTemplate = (await apiGet(
    `/property/${propertyId}/venue-template/${venueTemplateId}`
  )) as any;
  return venueTemplate;
}

export const populate = populateVenueTemplate;

export function bare(venueTemplate: VenueTemplate): BareVenueTemplate {
  return {
    ...venueTemplate,
    property: venueTemplate.property._id,
    types: venueTemplate.types.map(t => t._id),
  };
}

export async function create(newVenueTemplate: NewVenueTemplate): Promise<BareVenueTemplate> {
  return apiPost(`/property/${newVenueTemplate.property}/venue-template`, newVenueTemplate);
}

export async function update(venueTemplate: BareVenueTemplate): Promise<BareVenueTemplate> {
  return apiPut(
    `/property/${venueTemplate.property}/venue-template/${venueTemplate._id}`,
    venueTemplate
  );
}

export async function updateVenueOrder(
  propertyId: string,
  venueOrder: VenueOrder[]
): Promise<void> {
  return apiPost(`/property/${propertyId}/venue-order`, { venueOrder });
}

/**
 * Generates a CSV file with the Venue templates data
 */
export const exportVenueTemplatesToCSV = (propertyId: string) => {
  return apiGet<{ location: string }>(`/property/${propertyId}/venue-template/export-csv`);
};

export const uploadVenueAttributesFile = async (
  propertyId: string,
  venueTemplateId: string,
  file: File
): Promise<{ location: string; name: string }> => {
  const fd = new FormData();
  fd.append('attributesFile', file);

  return apiRequest(
    RequestMethod.Post,
    `/property/${propertyId}/venue-template/${venueTemplateId}/attributes-file`,
    true,
    null,
    fd,
    {
      'Content-Type': 'multipart/form-data',
    }
  );
};

export const uploadVenueImage = async (
  venueTemplate: VenueTemplate,
  file: File
): Promise<{ location: string; name: string }> => {
  const fd = new FormData();
  fd.append('venueImage', file);

  return apiRequest(
    RequestMethod.Post,
    `/brand/${venueTemplate.property.brand._id}/venue-template/${venueTemplate._id}/image`,
    true,
    null,
    fd,
    {
      'Content-Type': 'multipart/form-data',
    }
  );
};

export async function setArchived(venue: VenueTemplate): Promise<BareVenueTemplate> {
  return apiPut(`/brand/${venue.property.brand._id}/venue-template/${venue._id}/archived`, venue);
}
